import { useState } from 'react'
import './DriverModal.scss'
import { LocationSelect } from './LocationSelect'
import { useTranslation } from 'react-i18next'

export enum TypeList {
  glass = 'Glass',
  fuel = 'Fuel',
  bodyshop = 'Bodyshop',
  neuwagen = 'Neuwagen',
  tire = 'Tire',
  smr = 'SMR',
  // damage = 'Damage',
}

export function DriverModal() {
  const [btnActive, setBtnActive] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [showLocationSearch, setShowLocationSearch] = useState(false)
  const [selectedType, setSelectedType] = useState('')
  const { t } = useTranslation('common')

  const message = showLocationSearch ? t('DRIVER_WHERE') : `${t('DRIVER_HEADER')}. ${t('DRIVER_HELP')}`
  function handleTypeSelect(type: string) {
    setSelectedType(type)
    setShowLocationSearch(true)
  }

  function resetTypeSelect() {
    setSelectedType('')
    setShowLocationSearch(false)
  }
  //prettier-ignore
  function getContent (type: TypeList) {
      switch (type) {
        case TypeList.smr: return <><i className="icon-rmt icon"/> {t('DRIVER_TYPES_SMR')}</>
        case TypeList.tire: return <><i className="icon-tire-storage icon"/> {t('DRIVER_TYPES_TIRE')}</>
        case TypeList.fuel: return <><i className="icon-fuel icon"/> {t('DRIVER_TYPES_FUEL')}</>
        case TypeList.glass: return <><i className="icon-glassDamage2 icon"></i> {t('DRIVER_TYPES_GLASS')}</>
        // case TypeList.damage: return <><i className="icon-car-damage icon"></i> {t('DAMAGES')}</>
        case TypeList.bodyshop: return <><i className="icon-garage icon"></i> {t('DRIVER_TYPES_BODYSHOP')}</>
        case TypeList.neuwagen: return <><i className="icon-order icon"></i> {t('DRIVER_TYPES_NEUWAGEN')}</>
        default: return <></>
      }
    }

  function getCard(type: TypeList) {
    return (
      <li onClick={() => handleTypeSelect(type)} className="list-item" key={type}>
        <span>{getContent(type)}</span>
        <i className="icon-right"></i>
      </li>
    )
  }
  return (
    <div className="driverArea">
      <div
        className={`driverBtn ${btnActive ? 'active' : ''}`}
        onClick={() => {
          setModalOpen(!modalOpen)
          setBtnActive(!btnActive)
        }}
      >
        <img src="/peter.png" width="28" height="28" alt="Try Interfleet4Driver" />
        <span>{t('DRIVER_ASSISTANT')}</span>
      </div>

      {modalOpen && (
        <div className={`driver visible`}>
          <div className="driverTitleArea">
            <img src="/peter.png" width="43" height="43" alt="Peter" />
            <div className="msgTitle">
              <span>{message}</span>
            </div>
            {showLocationSearch && (
              <button onClick={resetTypeSelect} className="backBtn">
                <div className="backArea">{getContent(selectedType as TypeList)}</div>
              </button>
            )}
          </div>
          <ul className="choiceList">
            {Object.entries(TypeList).map(([, value]) => !showLocationSearch && getCard(value))}
            {showLocationSearch && <LocationSelect type={selectedType} />}
          </ul>
          <div className="poweredArea">
            Powered by
            <a href="https://driver.interfleet.ch" target="_blank">
              <img src="/logo-interfleetdriver.svg" width="134" height="22" alt="Interfleet4Driver" />
            </a>
          </div>
        </div>
      )}
    </div>
  )
}
